import { cn } from "@/lib/utils";
import { CustomIcons } from "@/components/icons/CustomIcons";

type BrandLogoVariant = "header" | "auth" | "mark";

const VARIANT_CLASSES: Record<BrandLogoVariant, string> = {
  auth: "h-[50px] w-[184px]",
  header: "h-[28px] w-[104px]",
  mark: "h-[22px] w-[22px]",
};

interface ApplicationBrandLogoProps {
  variant?: BrandLogoVariant;
  className?: string;
}

export function ApplicationBrandLogo({
  variant = "header",
  className,
}: ApplicationBrandLogoProps) {
  const iconName = variant === "mark" ? "logo-mark" : "logo";
  return <CustomIcons name={iconName} className={cn(VARIANT_CLASSES[variant], className)} />;
}
